import { IAction } from "../model/IAction";

export const UPDATE_DMN = "UPDATE_DMN";
export function updateDmn(): IAction {
  return {
    type: UPDATE_DMN,
  };
}
